import {Grid} from '@yandex-delivery/blocks'
import type {FC} from 'react'

import type {VerticalsWidgetProps as Props} from '../../types'
import {useVerticals} from '../hooks/use-verticals'
import {VerticalItem} from '../VerticalItem/VerticalItem'
import * as classes from '../VerticalsSection/VerticalsSection@mobile.classes'

export const VerticalsWidget: FC<Props> = props => {
  const {options, field} = useVerticals(props.config)

  return (
    <Grid xs={12} item>
      <div className={classes.wrapper.verticals}>
        {options.length !== 0
          ? options.map((itemProps, i) => (
              <div key={i} className={classes.wrapper.verticalItem}>
                <VerticalItem
                  active={field.value === itemProps.value}
                  onClick={field.onChange}
                  tag={itemProps.value === 'walking_courier' ? 'New!' : undefined}
                  {...itemProps}
                />
              </div>
            ))
          : null}
      </div>
    </Grid>
  )
}
